import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { simInfoColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getSimInfo } from "../../../../api/sim";

const COPY_KEYS = ["id", "msisdn", "status", "created_at", "last_updated"];

const VSSimInfoBatch = () => (
  <BatchDetail
    title="Sim Info"
    apiGet={__getSimInfo}
    client={CLIENTS.vs}
    columnsFactory={(ctx) => simInfoColumns({ ...ctx, showIccid: false, showWebhook: true })}
    copyKeys={COPY_KEYS}
    exportAction="sim_info"
    showTerminate
    terminateOperation="sim_info"
  />
);

export default VSSimInfoBatch;
